import { Box, CircularProgress, Typography } from "@mui/material";
import { Outlet } from "react-router-dom";
import { useRequest } from "../api/utils/useRequest";
import { BalootUserAPIs, BalootUserV2APIs } from "../api/APIs";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setIsSynced } from "../store/actions/AuthActions";
import { setConfig } from "../store/actions/ConfigActions";
import { useSnackBar } from "../context/SnackBarContext";
import { ReactComponent as Logo } from "../assets/icons/logo-name-white.svg";

function AppContainer() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const openSnack = useSnackBar();
  const {
    isFetched,
    loading,
    apiCall: sync,
  } = useRequest(BalootUserV2APIs.sync, true);

  const syncCall = () => {
    sync({
      onSuccess: (response) => {
        dispatch(setIsSynced(true));
        dispatch(setConfig({ config: response }));
        if (response.sejamInfo.status === "AUTHENTICATED") {
          navigate("/app", { replace: true });
        } else if (!response.personalInfo.nationalId) {
          navigate("/auth/national-id", { replace: true });
        } else if (
          !response.personalInfo.firstName &&
          !response.personalInfo.lastName
        ) {
          navigate("/auth/personal-info/first-name", { replace: true });
        } else {
          navigate("/app", { replace: true });
        }
      },
      onError: (error) => {
        openSnack(true, {
          message: error.message,
          actionTitle: "تلاش مجدد",
          action: syncCall,
        });
      },
    });
  };

  useEffect(() => {
    syncCall();
  }, []);

  return (
    <Box
      id="AppContainer"
      sx={{
        position: "relative",
        width: "100%",
        height: "100%",
        maxWidth: "600px",
        bgcolor: (theme) => theme.palette.primary.dark,
      }}
    >
      {loading || !isFetched ? (
        <Box
          sx={{
            height: "100%",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-between",
            p: 3,
          }}
        >
          <Box
            sx={{
              mt: 6,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Logo width={98} height={185} />

            {loading && (
              <CircularProgress
                size={"24px"}
                sx={{ color: "common.white", mt: 3 }}
              />
            )}
          </Box>

          <Typography variant="h4" color="common.white">
            0.1.0
          </Typography>
        </Box>
      ) : (
        <Outlet />
      )}
    </Box>
  );
}

export default AppContainer;
